require('./openYoungContactDataStep2.scss');

// @vendor
const React = require('react');
const PropTypes = require('prop-types');
const { formatText, FormattedText } = require('core/i18n').i18n;
const trim = require('lodash/string/trim');

// @utilities
const PersonalDataHelper = require('utilities/personalDataHelper');

// @components
const Highlighted = require('components/commons/highlighted/highlighted');
const { SignaturePattern } = require('components/signaturePattern/signaturePattern');
const OKInformativeList = require('components/rebrand/OKInformativeList/OKInformativeList');
const OKInformativeListItem = require('components/rebrand/OKInformativeListItem/OKInformativeListItem');
const ContactCenterRender = require('components/conditionalRender/contactCenterRender');
const {
    CONFIRMATION_SCRIPT_AGREEMENT,
    CONFIRMATION_SCRIPT_GREETING_WITH_SUMMARY,
    ConfirmationScript,
} = require('components/contactCenter/confirmScript/confirmationScript');

// @constants
const PROVINCES = require('constants/provinces');
const { getTranslatedCountry } = require('constants/countries');
const { getTranslatedRoad } = require('constants/typeOfRoads');
const { OPEN_YOUNG_UPDATE_PROFILE } = require('constants/operationTypes');
const { SPAIN_COUNTRY_CODE } = require('constants/index');


class OpenYoungContactDataStep2 extends React.Component {
    highlightComponentWrapper(status, value) {
        return <Highlighted isHighlighted={status}>{value}</Highlighted>;
    }

    isDirty(immHireContactData, field) {
        const initialValue = immHireContactData.getIn([`${field}Initial`, 'value']);

        return !!immHireContactData.get(field) &&
            initialValue !== undefined &&
            trim(initialValue) !== trim(immHireContactData.getIn([field, 'value']));
    }

    buildHighlightedModificationsMessage(){
        const message = this.highlightComponentWrapper(true, <FormattedText value="openYoungContactData-openYoungContactData_infoMessage02"/>);

        return (
            <p className="open-young-contact-data-step-2__subtitle">
                <FormattedText value="openYoungContactData-openYoungContactData_infoMessage01"/>
                {message}
            </p>
        );
    }

    formatMobile(immHireContactData) {
        const mobileNumber = {
            dirty: this.isDirty(immHireContactData, 'mobile'),
            value: PersonalDataHelper.formattedPhone(SPAIN_COUNTRY_CODE, immHireContactData.getIn(['mobile', 'value'])),
        };

        return this.highlightComponentWrapper(mobileNumber.dirty, mobileNumber.value);
    }

    formatAddress(immHireContactData) {
        const roadType = immHireContactData.getIn(['roadType', 'value']);
        const roadName = immHireContactData.getIn(['roadName', 'value']);
        const number = immHireContactData.getIn(['number', 'value']);
        const others = immHireContactData.getIn(['others', 'value']);
        const population = immHireContactData.getIn(['population', 'value']);
        const province = immHireContactData.getIn(['province', 'value']);
        const country = immHireContactData.getIn(['country', 'value']);
        const postalCode = immHireContactData.getIn(['postalCode', 'value']);
        const fields = [
            {
                dirty: this.isDirty(immHireContactData, 'roadType'),
                value: !!roadType ? getTranslatedRoad(roadType) : '',
            },
            {
                dirty: this.isDirty(immHireContactData, 'roadName'),
                value: !!roadName ? roadName : '',
            },
            {
                dirty: this.isDirty(immHireContactData, 'number'),
                value: (!!number ? number : '') + ',',
            },
            {
                dirty: this.isDirty(immHireContactData, 'others'),
                value: !!others ? (others + ',') : '',
            },
            {
                 dirty: this.isDirty(immHireContactData, 'population'),
                 value: !!population ? (population + ',') : '',
            },
            {
                dirty: this.isDirty(immHireContactData, 'province'),
                value: !!province ? (PROVINCES[province] + ',') : '',
            },
            {
                dirty: this.isDirty(immHireContactData, 'country'),
                value: !!country ? getTranslatedCountry(country) : '',
            },
            {
                dirty: this.isDirty(immHireContactData, 'postalCode'),
                value: !!postalCode ? `(${postalCode})` : '',
            }
        ];
        const addressFields = fields.map((field, index) => {
            const space = !!index ? ' ' : '';
            const highlightedField = this.highlightComponentWrapper(field.dirty, field.value);

            return (
                <span key={index}>
                    {space}
                    {highlightedField}
                </span>
            );
        });

        return <span>{addressFields}</span>;
    }

    render() {
        const { immHireContactData } = this.props;
        const confirmationMessage = this.buildHighlightedModificationsMessage();
        const mobileLabel = this.formatMobile(immHireContactData);
        const addressLabel = this.formatAddress(immHireContactData);
        const operative = formatText('operatives-openYoungBeneficiaryContactDataEdit');

        return (
            <article className="open-young-contact-data-step-2">
                <FormattedText
                    className="open-young-contact-data-step-2__title"
                    value="openYoungContactData-openYoungContactData_confirmationTitle"
                />
                <ContactCenterRender>
                    <ConfirmationScript operative={operative} confirmationType={CONFIRMATION_SCRIPT_GREETING_WITH_SUMMARY} />
                </ContactCenterRender>
                {confirmationMessage}
                <OKInformativeList columns={2}>
                    <OKInformativeListItem
                        title={formatText('openYoungContactData-openYoungContactData_newMobile')}
                        onlyChildren
                    >
                        {mobileLabel}
                    </OKInformativeListItem>
                    <OKInformativeListItem
                        title={formatText('openYoungContactData-openYoungContactData_newAddress')}
                        onlyChildren
                    >
                        {addressLabel}
                    </OKInformativeListItem>
                </OKInformativeList>
                <ContactCenterRender>
                    <ConfirmationScript confirmationType={CONFIRMATION_SCRIPT_AGREEMENT} />
                </ContactCenterRender>
                <SignaturePattern
                    operationType={OPEN_YOUNG_UPDATE_PROFILE}
                    operationParams={{}}
                />
            </article>
        );
    }
}

OpenYoungContactDataStep2.propTypes = {
    immHireContactData: PropTypes.object.isRequired,
};

module.exports = OpenYoungContactDataStep2;
